export const GET_REPORT_ARTICLES = "GET_REPORT_ARTICLES";
export const GET_REPORT_ARTICLES_SUCCESS = "GET_REPORT_ARTICLES_SUCCESS";
export const GET_REPORT_ARTICLES_FAIL = "GET_REPORT_ARTICLES_FAIL";
